import cn from 'classnames';
import { FC, MouseEventHandler, ReactNode } from 'react';

import { Icon } from '../Icon/Icon';
import { IconNames } from '../Icon/Icon.types';

import { type TimelinePreview } from './Timeline.types';
import { TimelinePreviewImage } from './TimelinePreviewImage';
import styles from './TimelineRow.module.scss';

type TimelineRowProps = {
  title: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  dataComponent?: string;
  icon?: IconNames;
  iconSize?: number;
  isClickable?: boolean;
  isHidden?: boolean;
  isRemoving?: boolean;
  meta?: ReactNode;
  preview?: TimelinePreview;
  testID?: string;
  time?: ReactNode;
  onAuxClick?: MouseEventHandler<HTMLDivElement>;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

export const TimelineRow: FC<TimelineRowProps> = (props) => {
  const {
    title,
    actions,
    children,
    className,
    dataComponent,
    icon,
    iconSize = 28,
    isClickable = Boolean(props.onClick),
    isHidden,
    isRemoving,
    meta,
    preview,
    testID,
    time,
    onAuxClick,
    onClick,
  } = props;

  return (
    <div
      data-component={dataComponent}
      data-testid={testID}
      className={cn(
        styles.container,
        !isClickable && styles.notClickable,
        isRemoving && styles.removing,
        isHidden && styles.hidden,
        className,
      )}
      onClick={onClick}
      onAuxClick={onAuxClick}
    >
      {time !== undefined && (
        <span className={cn('p2', styles.time)}>{time}</span>
      )}

      {icon && <Icon name={icon} size={iconSize} className={styles.icon} />}

      {preview && (
        <TimelinePreviewImage {...preview} className={styles.preview} />
      )}

      <div className={styles.content}>
        <h4 className={cn('h5', styles.title)}>{title}</h4>

        {meta && <p className={cn('p2', styles.meta)}>{meta}</p>}

        {children}
      </div>

      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};
